import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from './redux/blockchain/blockchainActions';
import { fetchData } from './redux/data/dataActions';
import * as s from './styles/globalStyles';
import styled from 'styled-components';
const Web3 = require("web3");

const web3 = new Web3();

const axios = require('axios');

const truncate = (input, len) =>
	input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
	margin: 15px;
	border: solid;
	background-color: Black;
	padding: 10px;
	font-weight: bold;
	color: var(--secondary-text);
	width: 20%;
	cursor: pointer;
`;

export const StyledRoundButton = styled.button`
	padding: 20px;
	border: none;
	background-color: var(--primary);
	padding: 20px;
	font-weight: bold;
	font-size: 15px;
	color: var(--primary-text);
	width: 30px;
	height: 30px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
	-webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
	-moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
	:active {
		box-shadow: none;
		-webkit-box-shadow: none;
		-moz-box-shadow: none;
	}
`;

export const ResponsiveWrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: stretched;
	align-items: stretched;
	width: 100%;
	@media (min-width: 767px) {
		flex-direction: row;
	}
`;

export const StyledLogo = styled.img`
	//padding-top: 10%;
	width: 150px;
	@media (min-width: 767px) {
		width: 400px;
		padding-right: 50px;
	}
	transition: width 0.5s;
	transition: height 0.5s;
`;

export const StyledImg = styled.img`
	background-color: var(--accent);

	@media (min-width: 900px) {
		width: 100%;
		height: 100%;
		top: 0;
		bottom: 0;
	}
	@media (min-width: 1000px) {
		width: 150%;
		height: 100%;
		top: 0;
		bottom: 0;
	}
	transition: width 0.5s;
`;

export const StyledLink = styled.a`
	color: var(--secondary);
	text-decoration: none;
`;

let nextId = 0;

export default function Mint() {
	const dispatch = useDispatch();
	const blockchain = useSelector((state) => state.blockchain);
	const data = useSelector((state) => state.data);
	const [claimingNft, setClaimingNft] = useState(true);
	const [WLbuy, setWLbuy] = useState(false);
	const [IdArray, setIdArray] = useState([]);
	const [TokenId, setTokenId] = useState(1);
	const [feedback, setFeedback] = useState(
		`If you're holding a B2DC NFT claim your Aibois Here`
	);

	const [mintAmount, setMintAmount] = useState(1);
	const [CONFIG, SET_CONFIG] = useState({
		CONTRACT_ADDRESS: '0xCE2C03E581e2D17F65dD6E642cB48b591022A134',
		SCAN_LINK: 'https://etherscan.io/address/0xCE2C03E581e2D17F65dD6E642cB48b591022A134',
		NETWORK: {
			NAME: 'Ethereum',
			SYMBOL: 'ETH',
			ID: 1,
		},
		NFT_NAME: 'Bored 2 death Aibois',
		SYMBOL: 'NFT',
		MAX_SUPPLY: "1332",
		WEI_COST: 66600000000000000,
		DISPLAY_COST: 0.0666,
		GAS_LIMIT: 300000,
		MARKETPLACE: '',
		MARKETPLACE_LINK: 'https://opensea.io/collection/',
		SHOW_BACKGROUND: true,
	});

	const claimAIboisFT = async () => {
		let cost = CONFIG.WEI_COST;
		let gasLimit = CONFIG.GAS_LIMIT;
		let totalCostWei = String(cost * mintAmount);
		let totalGasLimit = String(gasLimit * 1);
		console.log('Cost: ', totalCostWei);
		console.log('Gas limit: ', totalGasLimit);
		setFeedback(`Claiming your ${CONFIG.NFT_NAME}...`);
		console.log('allllllo', TokenId);
		setClaimingNft(true);
		const map1 = IdArray.map(X => X.TokenId.toString());
		blockchain.smartContract.methods
			.claim(map1)
			.send({
				gasLimit: String(totalGasLimit),
				to: CONFIG.CONTRACT_ADDRESS,
				from: blockchain.account,
			})
			.once('error', (err) => {
				console.log(err);
				setFeedback('Sorry, something went wrong please try again later.');
				setClaimingNft(false);
			})
			.then((receipt) => {
				console.log(receipt);
				setFeedback(`HOLIAAAA `);
				setClaimingNft(false);
				dispatch(fetchData(blockchain.account));
			});
	};

	const Mint = async () => {
		let cost = 99900000000000000;
		let gasLimit = CONFIG.GAS_LIMIT;
		let totalCostWei = String(cost * mintAmount);
		let totalGasLimit = String(gasLimit * mintAmount);
		console.log('Cost: ', totalCostWei);
		console.log('Gas limit: ', totalGasLimit);
		setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
		setClaimingNft(true);
		console.log(String(blockchain.account));
		blockchain.smartContract.methods
			.mint(mintAmount)
			.send({
				gasLimit: String(totalGasLimit),
				to: CONFIG.CONTRACT_ADDRESS,
				from: blockchain.account,
				value: totalCostWei,
			})
			.once('error', (err) => {
				console.log(err);
				setFeedback('Sorry, something went wrong please try again later.');
				setClaimingNft(false);
			})
			.then((receipt) => {
				console.log(receipt);
				setFeedback(`HOLIAAAA `);
				setClaimingNft(false);
				dispatch(fetchData(blockchain.account));
			});
	};


	const handleChangeTokenId = event => {
		setTokenId(event.target.value);

		//console.log('value is:', event.target.value);
		//console.log(TokenId);
	};

	const handleClickAdd = () => {
		setTokenId(1)
		setIdArray([
			...IdArray,
			{ id: nextId++, TokenId: TokenId }
		]);
		setClaimingNft(false);
	};

	const handleClickedClaim = () => {



	};


	const decrementMintAmount = () => {
		let newMintAmount = mintAmount - 1;
		if (newMintAmount < CONFIG.MAX_MINT) {
			newMintAmount = CONFIG.MIN_MINT;
		}
		setMintAmount(newMintAmount);
	};

	const incrementMintAmount = () => {
		let newMintAmount = mintAmount + 1;
		if (newMintAmount > CONFIG.MIN_MINT) {
			newMintAmount = CONFIG.MAX_MINT;
		}
		setMintAmount(newMintAmount);
	};

	const getData = () => {
		if (blockchain.account !== '' && blockchain.smartContract !== null) {
			dispatch(fetchData(blockchain.account));

		} else {

		}
		//let result = checkSignature(blockchain.account);
		//console.log(result);

	};

	const getConfig = async () => {
		/*const configResponse = await fetch('/config/config.json', {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		});
		const config = await configResponse.json();
		SET_CONFIG(config);*/
	};

	useEffect(() => {
		getConfig();


	});

	useEffect(() => {
		getData();
	}, [blockchain.account]);

	return (

		<s.Screen>
			<s.Container
				flex={1}
				ai={'center'}
				style={{ padding: 0, backgroundColor: 'var(--primary)', backgroundColor: 'black' }}
				image={
					CONFIG.SHOW_BACKGROUND ? '/config/images/background.jpg' : null
				}
			>


				<ResponsiveWrapper flex={1} style={{ /*padding: '120px', */ }} test>
					<s.Container
						flex={2}
						jc={'center'}
						ai={'center'}
						style={{
							padding: 0,
							borderRadius: '25px',

						}}
					>
						<s.SpacerSmall />
						{Number(data.totalSupply) >= CONFIG.STAGELIMIT ? (
							<>
								<s.TextTitle
									style={{ textAlign: 'center', color: 'var(--accent-text)' }}
								>
									If you're holding a B2DC NFT claim your Aibois Here
								</s.TextTitle>

								<s.SpacerSmall />
								<StyledLink target={'_blank'} href={CONFIG.MARKETPLACE_LINK}>
									{CONFIG.MARKETPLACE}
								</StyledLink>
							</>
						) : (
							<>
								{/*<s.TextTitle
									style={{ textAlign: 'center', color: 'var(--accent-text)' }}
								>
									1 {CONFIG.SYMBOL} costs {CONFIG.DISPLAY_COST}{' '}
									{CONFIG.NETWORK.SYMBOL}.
								</s.TextTitle>
								<s.SpacerXSmall />
								<s.TextDescription
									style={{ textAlign: 'center', color: 'var(--accent-text)' }}
						>
									Excluding gas fees.
								</s.TextDescription>*/}

								<s.SpacerSmall />
								{blockchain.account === '' ||
									blockchain.smartContract === null ? (
									<s.Container ai={'center'} jc={'center'}>
										<s.TextDescription
											style={{
												textAlign: 'center',
												color: 'var(--accent-text)',
											}}
										>
											Connect to the {CONFIG.NETWORK.NAME} network
										</s.TextDescription>
										<s.SpacerSmall />
										<StyledButton
											onClick={(e) => {
												e.preventDefault();
												dispatch(connect())
												getData();

											}}
										>
											CONNECT
										</StyledButton>
										{blockchain.errorMsg !== '' ? (
											<>
												<s.SpacerSmall />
												<s.TextDescription
													style={{
														textAlign: 'center',
														color: 'var(--accent-text)',
													}}
												>
													{blockchain.errorMsg}
												</s.TextDescription>
											</>
										) : null}
									</s.Container>
								) : (
									<>
										<s.TextDescription
											style={{
												textAlign: 'center',
												color: 'var(--accent-text)',
												fontSize: '190%'
											}}
										>
											{feedback}
										</s.TextDescription>
										<s.SpacerMedium />
										<s.Container ai={'center'} jc={'center'} fd={'row'}>
											<s.TextDescription
												style={{
													textAlign: 'center',
													color: 'var(--accent-text)',
													fontSize: '120%'
												}}
											>
												What's Your NFT #ID ?
											</s.TextDescription>
											<s.SpacerMedium />
											<input
												type="number"
												id="TokenId"
												name="TokenId"
												min={1}
												onChange={handleChangeTokenId}
												value={TokenId}
												style={{
													textAlign: 'center',
													fontSize: '20px',
													fontWeight: 'bold',
													//color: 'black',
													margin: '20px',
													width: '20%',
													padding: '20px'
												}}
											/>
											<StyledButton
												id='Add_id'
												style={{
													textAlign: 'center',
													fontSize: '20px',
													fontWeight: 'bold',
													width: '6%',

												}}
												onClick={(e) => {
													handleClickAdd();
												}}
											>
												+
											</StyledButton>
											<s.SpacerLarge />


										</s.Container>
										<s.SpacerSmall />
										<s.Container ai={'center'} jc={'center'} style={{
											padding: 20,
											borderRadius: '25px',

										}}>
											<s.TextDescription
												style={{
													textAlign: 'center',
													color: 'var(--accent-text)',
													fontSize: '120%',
													width: '300px'
												}}
											>
												#IDs
											</s.TextDescription>
											<s.TextDescription
												style={{
													textAlign: 'center',
													color: 'var(--accent-text)',
													fontSize: '150%',
													display: 'block'
												}}
											>
												{IdArray.map(id => (
													<li style={{
														width: '190%',
														textAlign: 'left',
													}} key={id.id}>{id.TokenId}
														<StyledButton
															style={{
																textAlign: 'center',
																//fontSize: '20px',
																fontWeight: 'bold',
																width: '59%'
															}}
															onClick={() => {
																//console.log('click');
																//console.log('old', IdArray);
																setIdArray(
																	IdArray.filter(a =>
																		a.id !== id.id
																	)
																);
																//console.log('New', IdArray);
																//console.log('a', id);
															}}>
															Delete
														</StyledButton></li>
												))}


											</s.TextDescription>
										</s.Container>
										<s.Container ai={'center'} jc={'center'} >
											<StyledButton
												id='Claim_id'
												disabled={claimingNft ? 1 : 0}
												hidden={claimingNft ? 1 : 0}
												onClick={(e) => {
													e.preventDefault();
													claimAIboisFT();
													getData();
												}}
											>
												{claimingNft ? 'BUSY' : 'Claim Deadboi'}
											</StyledButton>
										</s.Container>
									</>
								)}
							</>
						)}
						<s.SpacerMedium />
						<s.SpacerMedium />
						<s.SpacerMedium />
					</s.Container>
					<s.SpacerLarge />
					{/* here image  */}

				</ResponsiveWrapper>


			</s.Container >
		</s.Screen >
	);
}
